import { Skeleton } from '@/components/ui/Skeleton';

// Shown while a lazily-loaded route chunk is being fetched. Mirrors the
// rough shape of a typical admin page (title + toolbar + content block) so
// the swap into the real page is visually quiet rather than a hard flash.
export function RouteFallback() {
  return (
    <div className="space-y-6" aria-busy="true" aria-label="Loading">
      <div className="flex items-center justify-between">
        <Skeleton className="h-7 w-48" />
        <Skeleton className="h-9 w-32" />
      </div>
      <Skeleton className="h-10 w-full max-w-sm" />
      <div className="space-y-3">
        {Array.from({ length: 8 }).map((_, i) => (
          <Skeleton key={i} className="h-12 w-full" />
        ))}
      </div>
    </div>
  );
}
